import React from "react";
import "./TopBanner.css";
import Typewriter from "typewriter-effect";

const TopBanner = () => {
  return (
    <div
      style={{ height: "85vh" }}
      className="d-flex justify-content-center align-items-center .Top-banner-style"
    >
      <div>
        <h1 className="text-center text-white Top-banner-title">
          I'M <span style={{ color: "#0000ff" }}>MOSHEUR</span>{" "}
          <span> RAHMAN</span>
        </h1>
        <h1 className="text-white">
          <Typewriter
            options={{
              strings: [
                `<strong><span style="color: #0000ff;">MERN</span> Stack </strong> Developer`,
                `<strong><span style="color: #7EC8E3;">Front</span> End </strong> Developer`,
                `<strong><span style="color: #0000ff;">Full</span> Stack </strong> Developer`,
                `<strong><span style="color: #7EC8E3;">Software</span></strong> Engineer`,
                `<strong><span style="color: #0000ff;">Content</span></strong> Creator`,
                `<strong><span style="color: #7EC8E3;">Programmer</span></strong>`,
              ],
              autoStart: true,
              loop: true,
            }}
          />
        </h1>
        <a
          href="https://drive.google.com/file/d/11xA8_vSs9MhQ0owbWwh3p3nS9Cvuk0WE/view"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button type="button" class="btn-All">
            Open Resume
          </button>
        </a>
      </div>
    </div>
  );
};

export default TopBanner;
